var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 44,
    viewBox: "0 0 101 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39515_29932",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100.111,
    height: 43.9513,
    fill: "url(#pattern0_39515_29932)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39515_29932)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.00223,
    y: -1.83142,
    width: 98.109,
    height: 45.7826,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_39515_29932",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_39515_29932",
    transform: "scale(0.00609756 0.0138889)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_39515_29932",
    width: 164,
    height: 72,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAYAAAB4M164AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAApKADAAQAAAABAAAASAAAAADMQLJYAAAC1UlEQVR4Ae3cUW4bIRQFUKdL6gpGXXjtFbQ76hSU+iMpDAP0Da50LFmRGXgPTm6UH+TbzYsAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECLyYwL7v9/T+X1/3Fmc62H3icM36wf2/H9VP53qbPN+Po/qtZxH984H2VuNXfv6WXkf7mz1fq/5R7/xssv+e+n+p9Ui189l/1Z6fGD+s31of0b962NZmPCcQISCQEapqDgsI5DCdhRECAhmhquawgEAO01kYISCQEapqDgsI5DCdhRECAhmhquawgEAO01kYISCQEapqDgsI5DCdhRECAhmhquawgEAO01kYISCQEaofaz4+fuz6dGbtmTm1pjNrnzVnavy9Nl+Pmnxtz531/kx9t8nezatzs/Un10/fp+w17Zmfzrb0PmVpr9P3IRffF7y1+udAlQ5+1Vhrf1fto9QnBzKNL7tPWdqTf9klFWPLBARyGb3GJQGBLKkYWyYgkMvoNS4JCGRJxdgyAYFcRq9xSUAgSyrGlgkI5DJ6jUsCAllSMbZMQCCX0WtcEhDIkoqxZQICuYxe45KAQJZUjC0TmA5kujGyje5+Zu1oz4vXPS7uN9JuZo/Vtfkm0Zn35w1PXz/7XPDqz63rXQll6vpZq37rvKl9vhO5teZVnt9T/2+VZ/mr/vL1sfwdklttTmP8Z6r/tTGn+jiiv0BWud8f/INAzvxBHH5/459ALLvPGNF/+l924/fpMYEuAYHs4jI5WkAgo4XV7xIQyC4uk6MFBDJaWP0uAYHs4jI5WkAgo4XV7xIQyC4uk6MFBDJaWP0uAYHs4jI5WkAgo4XV7xIQyC4uk6MFBDJaWP0ugRzIR9eK15p8Zu9n5tRONbP2WXOmxpm1eU6+UTTyPlM/lT585et1I73zmsdhZQ8JECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMALCPwGFCiub9eQwB0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.2ee25c01fa8b0879cdd71af3c8378b46.svg";
export { ForwardRef as ReactComponent };